import { ChevronDown, ChevronRight, Close } from '@carbon/icons-react';
import React, { useState } from 'react';
import { Clickable } from '@routable/gross-ds';
import clsx from 'clsx';
import { Sparkle } from '../Sparkle';
const noop = () => { };
export const SectionMessage = ({ children, customAction, isCollapsible, message, onClose, title, }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    return (React.createElement("div", { className: "flex p-5 bg-ai-section-message-gradient border border-solid border-grey-10 bg-purple-0 gap-6" },
        React.createElement("div", { className: "flex gap-3 flex-grow" },
            React.createElement("div", { className: "text-purple-50 pt-1" },
                React.createElement(Sparkle, { size: 16 })),
            React.createElement("div", { className: "flex flex-col text-sm text-black flex-grow gap-3" },
                title && React.createElement("span", { className: "font-semibold text-black text-sm" }, title),
                (message || children) && (!isCollapsible || !isCollapsed) && (React.createElement("div", { className: "flex flex-col gap-3" },
                    message,
                    children)))),
        React.createElement("div", { className: "pt-1 cursor-pointer text-grey-70" },
            isCollapsible && isCollapsed && React.createElement(ChevronRight, { onClick: () => setIsCollapsed(false), size: 16 }),
            isCollapsible && !isCollapsed && React.createElement(ChevronDown, { onClick: () => setIsCollapsed(true), size: 16 }),
            onClose && !isCollapsible && React.createElement(Close, { className: "cursor-pointer", onClick: onClose, size: 16 }),
            !isCollapsible && !onClose && customAction)));
};
SectionMessage.ActionsSection = ({ children }) => React.createElement("div", { className: "flex gap-5" }, children);
SectionMessage.Action = ({ children, loading, onClick }) => (React.createElement(Clickable, { className: clsx('text-sm underline-offset-4', {
        'cursor-wait': loading,
    }), variant: "black", onClick: loading ? noop : onClick }, children));
